import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Square, Menu, X } from 'lucide-react';
import { WaitlistModal } from './WaitlistModal';
export function HeroSection() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);
  const openWaitlist = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsWaitlistOpen(true);
    setIsMenuOpen(false); // Close mobile menu if open
  };
  return <section className="relative w-full flex flex-col items-center pt-32 pb-20 px-4 bg-[#FAF9F7]" data-id="element-34">
      <WaitlistModal isOpen={isWaitlistOpen} onClose={() => setIsWaitlistOpen(false)} data-id="element-35" />

      {/* Floating Header */}
      <nav className="fixed top-6 left-1/2 -translate-x-1/2 z-50 w-[90%] max-w-fit" data-id="element-36">
        <div className="bg-white/80 backdrop-blur-md border border-[#E8E6E3] rounded-2xl p-2 pl-6 pr-2 flex items-center justify-between gap-6 md:gap-12 shadow-[0_4px_20px_rgba(0,0,0,0.03)]" data-id="element-37">
          <div className="flex items-center gap-2" data-id="element-38">
            <img src="https://cdn.magicpatterns.com/uploads/wQE7QmjfHEAhLLQxvhgUnU/Andoe_Logo.png" alt="Andoe Logo" className="h-5 w-auto opacity-90" data-id="element-39" />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1 rounded-xl" data-id="element-40">
            <a href="#" className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-2 rounded-lg" data-id="element-41">
              Login
            </a>
            <button onClick={openWaitlist} className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-2 rounded-lg flex items-center" data-id="element-42">
              Join Waitlist <span className="ml-1" data-id="element-43">→</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-[#5C5C5C] hover:text-[#0F0F0F] transition-colors" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-44">
            {isMenuOpen ? <X className="h-5 w-5" data-id="element-45" /> : <Menu className="h-5 w-5" data-id="element-46" />}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMenuOpen && <div className="absolute top-full left-0 right-0 mt-2 bg-white/95 backdrop-blur-md border border-[#E8E6E3] rounded-2xl p-2 shadow-[0_4px_20px_rgba(0,0,0,0.03)] flex flex-col gap-1 md:hidden animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-47">
            <a href="#" className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-3 rounded-xl text-center" data-id="element-48">
              Login
            </a>
            <button onClick={openWaitlist} className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-3 rounded-xl text-center flex items-center justify-center w-full" data-id="element-49">
              Join Waitlist <span className="ml-1" data-id="element-50">→</span>
            </button>
          </div>}
      </nav>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto text-center mt-12 md:mt-16 space-y-10" data-id="element-51">
        <h1 className="text-4xl md:text-7xl font-medium tracking-tight text-[#0F0F0F] leading-[1.1]" data-id="element-52">
          The future of marketing is
          <br data-id="element-53" />
          AI search visibility.
        </h1>

        <div className="max-w-2xl mx-auto" data-id="element-54">
          <p className="text-lg md:text-2xl leading-relaxed text-[#5C5C5C] font-normal" data-id="element-55">
            Simply start by adding custom prompts and competitors.
            <br data-id="element-56" />
            We analyze the rest.
          </p>
        </div>

        <div className="pt-6 flex flex-col items-center gap-4" data-id="element-57">
          <Button variant="editorial" className="text-base md:text-lg px-8 py-4 h-auto rounded-xl" onClick={openWaitlist} data-id="element-58">
            Join Waitlist <span className="ml-2" data-id="element-59">→</span>
          </Button>
        </div>
      </div>
    </section>;
}